import { styled, TableCell as MUITableCell, Skeleton } from '@mui/material'

export const TableCell = styled(MUITableCell, {
  shouldForwardProp: (prop) => prop !== 'omitBorder',
})<{ omitBorder?: boolean }>`
  ${({ omitBorder }) => omitBorder && 'border: none;'}
`

export const BodySkeleton = styled(Skeleton, {
  shouldForwardProp: (prop) => prop !== 'width',
})<{ width?: number }>`
  width: ${({ theme, width }) => theme.spacing(width ?? 5)};
  height: ${({ theme }) => theme.spacing(2.5)};
`

export const CaptionSkeleton = styled(Skeleton, {
  shouldForwardProp: (prop) => prop !== 'width',
})<{ width?: number }>`
  width: ${({ theme, width }) => theme.spacing(width ?? 5)};
  height: ${({ theme }) => theme.spacing(1.75)};
`
